import Vue from 'vue'
import App from './App.vue'
import router from './router'
// import './assets/rem'  // 已使用postcss-px-to-vw 替代
import './assets/reset.css'
import 'swiper/dist/css/swiper.css' // vue-awesome-swiper


import VueDirectiveImagePreviewer from 'vue-directive-image-previewer'
import 'vue-directive-image-previewer/dist/assets/style.css'
Vue.use(VueDirectiveImagePreviewer,{
  maxWidth:'100%'
}) 


import axios from 'axios'
// 为axios添加自定义 jsonp方法, 并传入回调函数名
axios.jsonp = (url, callback) => {
  if(!url){
    console.error('Axios.JSONP 至少需要一个url参数!')
    return;
  }
  return new Promise((resolve,reject) => {
    // 此处将回调函数名加入 window, 并传入 Promise.resolve
    window[callback] = (result) => {
        resolve(result)
    }
    // 创建跨域请求
    const JSONP=document.createElement("script");
    JSONP.type="text/javascript";
    JSONP.src=`${url}`;
    document.getElementsByTagName("head")[0].appendChild(JSONP);
    setTimeout(() => {
        document.getElementsByTagName("head")[0].removeChild(JSONP)
    },500)
  })
}

// 配置axios baseURL
axios.defaults.baseURL = process.env.NODE_ENV === 'development' ? 'https://xyhdp.51job.com/evpapi/index.php/yun/index/' : 'https://xyhdp.51job.com/evpapi/index.php/yun/index/'

import EventBus from './eventBus'
Vue.prototype.$eventBus = new EventBus()

import store from './store'

Vue.config.productionTip = false

// 注册自定义全局插件
// Vue.prototype.$store = Store;
Vue.prototype.$http = axios;

export default new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')